import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';

@Component({
  selector: 'app-user-access-privilege',
  standalone: false,
  templateUrl: './user-access-privilege.component.html',
  styleUrl: './user-access-privilege.component.scss'
})
export class UserAccessPrivilegeComponent implements OnInit, OnDestroy {
  roles = [];
  selectedRole = null;
  showMenuDialog = false;
  flatModules = [];
  permissions: any[] = ['Add', 'Edit', 'View', 'Delete'];
  menuForm!: FormGroup;
  parentMenuOptions = [];
  dialogMode: string;
  isSubMenu: any;
  selectedMenu: any;
  showDeleteDialog: boolean = false;
  showEditMenuDialog: boolean = false;
  showParentDropdown: boolean = false
  expandedMenus: Set<number> = new Set();
  private mySubscription = new Subscription();
  schemes: any;
  filteredSchemes: any[];
  constructor(
    private apiService: ApiService, private fb: FormBuilder, private messageService: MessageService,private permissionService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.getRoles();
    // this.getMenus();
    this.getPrivilege();
    this.menuForm = this.fb.group({
      name: ['', Validators.required],
      url: ['/'],
      icon: ['MessageSquare'],
      parent: [null],
      isSchemeMenu: [false],
      scheme: [null],
    });
        // Subscribe to checkbox changes
    this.menuForm
      .get('isSchemeMenu')
      ?.valueChanges.subscribe((checked: boolean) => {
        const schemeControl = this.menuForm.get('schemeId');

        if (checked) {
          // Make the dropdown required
          schemeControl?.setValidators([Validators.required]);
          this.getSchemes(); // Call API only when checkbox is selected
        } else {
          // Remove validators and clear selected scheme
          schemeControl?.clearValidators();
          schemeControl?.setValue(null);
        }

        schemeControl?.updateValueAndValidity();
      });
  }
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }
    getSchemes() {
    const sub = this.apiService
      .getAPI('/master/scheme/?dropdown=true')
      .subscribe((res: any) => {
        this.schemes = res;
        this.filteredSchemes = [...this.schemes]
      });
  }
  saveChanges() {
    const menu_access = this.buildMenuAccess(this.flatModules);

    const payload = {
      user: { id: this.selectedRole.id },
      menu_access
    };

    const sub = this.apiService.postAPI(`/access/user-menu-mappings/`, payload).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Permissions saved successfully!'
        });
      },
      error: (err) => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to save permissions. Please try again.'
        // });
        console.error('Save failed:', err);
      }
    });
    this.mySubscription.add(sub)
  }
  getDialogHeader(): string {
    if (this.dialogMode === 'add') {
      return this.isSubMenu ? 'Add Sub Menu' : 'Add Menu';
    } else if (this.dialogMode === 'edit') {
      return this.isSubMenu ? 'Edit Sub Menu' : 'Edit Menu';
    }
    return 'Menu';
  }


  openAddMenuDialog(isSubMenu: boolean, parentMenu: any = null) {
    this.menuForm.reset();
    this.isSubMenu = isSubMenu;
    this.showParentDropdown = isSubMenu;
    this.dialogMode = 'add';
    this.getParentMenu()
    if (isSubMenu && parentMenu) {
      this.menuForm.patchValue({ parent: parentMenu.id });
    }

    this.showMenuDialog = true;
  }

  editMenu(menu: any, hasParent: boolean) {
    // this.menuForm.reset();
    this.dialogMode = 'edit';
    this.isSubMenu = hasParent;
    this.showParentDropdown = true;
    this.getParentMenu()
    this.selectedMenu = menu;
    // Fetch parent menus first
    const sub = this.apiService.getAPI('/access/menus/').subscribe((res: any[]) => {
      if (res) {
        this.parentMenuOptions = res;

        // Now patch the form after options are loaded
        // Find the parent object by matching ID
        const parentMenuObj = this.parentMenuOptions.find(p => p.id == menu.id);
        this.menuForm.patchValue({
          name: menu.name,
          url: menu.url,
          icon: menu.icon,
          parent: parentMenuObj ? parentMenuObj.parent : null
        });

        // Show dialog after data is ready
        this.showEditMenuDialog = true;
      }
    });
    this.mySubscription.add(sub)

  }

  saveEditMenu() {
    if (this.menuForm.valid) {
      const payload = {
        name: this.menuForm.get('name')?.value,
        parent: this.menuForm.get('parent')?.value || null,
        url: this.menuForm.get('url')?.value,
        icon: this.menuForm.get('icon')?.value,
        sequence: 1,
        status: 1,
          ...(this.menuForm.get('isSchemeMenu')?.value && {
          scheme_id: this.menuForm.get('scheme')?.value,
        }),
      };

      const sub = this.apiService.putAPI(`/access/menus/${this.selectedMenu.id}/`, payload).subscribe({
        next: res => {
          this.getMenus();
           this.getUserMapping();
          this.menuForm.reset();
          this.showEditMenuDialog = false;
        },
        error: err => {
          console.error('Edit menu error', err);
        }
      });
      this.mySubscription.add(sub)
    }
  }


  saveMenu() {
    if (this.menuForm.valid) {
      const payload = {
        name: this.menuForm.get('name')?.value,
        parent: this.isSubMenu ? this.menuForm.get('parent')?.value : null,
        url: this.menuForm.get('url')?.value,
        icon: this.menuForm.get('icon')?.value,
        sequence: 1,
        status: 1,
          ...(this.menuForm.get('isSchemeMenu')?.value && {
          scheme_id: this.menuForm.get('scheme')?.value,
        }),
      };

      const sub = this.apiService.postAPI('/access/menus/', payload).subscribe({
        next: res => {
          this.getMenus();
          this.getUserMapping();
          this.menuForm.reset();
          this.showMenuDialog = false;
        },
        error: err => {
          console.error('Add menu error', err);
        }
      });
      this.mySubscription.add(sub)
    }
  }

  getMenus() {
    const sub = this.apiService.getAPI('/access/nested-menus/').subscribe((res: any[]) => {

      const transformMenu = (menu: any): any => {
        const permissions: { [key: string]: boolean } = {};

        this.permissions.forEach(privName => {
          const matched = menu.privileges?.find((p: any) => p.name === privName);
          permissions[privName] = matched ? matched.status === true : false;
        });

        return {
          ...menu,
          permissions,
          enabled: false,
          children: (menu.sub_menus || []).map((child: any) => transformMenu(child))
        };
      };

      this.flatModules = res.map(item => transformMenu(item));
      this.parentMenuOptions = [...this.flatModules];
    });

    this.mySubscription.add(sub);
  }


  getUserMapping() {
    const sub = this.apiService.getAPI(`/access/user-menu-mappings/?user_id=${this.selectedRole.id}`).subscribe((res: any[]) => {
      if (res) {
        const mappedModules = res.map(menu => this.mapMenuPrivileges(menu));

        this.flatModules = mappedModules;
      }
    });
    this.mySubscription.add(sub)
  }
  getRoles() {
    const sub = this.apiService.getAPI('/account/users/').subscribe((res: any) => {
      this.roles = res.data;
      // this.filteredSchemes = [...this.schemes]
    });
    this.mySubscription.add(sub)
  }
  getPrivilege() {
    const sub = this.apiService.getAPI(`/access/privileges/`).subscribe((res: any) => {

      this.permissions = res.data;
      this.getMenus();

    });
    this.mySubscription.add(sub)
  }
  buildMenuAccess(modules: any[]): any[] {
    return modules.map(mod => {
      const privileges = this.permissions.map(priv => ({
        id: priv.id,
        name: priv.name,
        description: priv.description,
        status: mod.permissions[priv.name] || false
      }));

      return {
        id: mod.id,
        name: mod.name,
        url: mod.url,
        icon: mod.icon || "icon",
        sub_menus: this.buildMenuAccess(mod.children || []),
        privileges
      };
    });
  }
  mapMenuPrivileges(menu: any): any {
    const permissions: { [key: string]: boolean } = {};

    // Initialize all permissions to false
    this.permissions.forEach(priv => {
      permissions[priv.name] = false;
    });

    // Set permission from backend data if available
    if (menu.privileges && Array.isArray(menu.privileges)) {
      menu.privileges.forEach((priv: any) => {
        const matched = this.permissions.find(p => p.id === priv.id);
        if (matched) {
          permissions[matched.name] = priv.status === true;
        }
      });
    }

    const children = (menu.sub_menus || []).map(child => this.mapMenuPrivileges(child));
    const isEnabled = Object.values(permissions).some(val => val === true) || children.some(c => c.enabled);

    return {
      ...menu,
      permissions,
      enabled: isEnabled,
      children
    };
  }

  // onPermissionChange(module: any): void {
  //   // Update enabled flag based on permissions
  //   module.enabled = Object.values(module.permissions).some(val => val === true);

  //   // Propagate up to parents
  //   this.propagateToParent(this.flatModules, module);

  //   // Propagate down to children
  //   if (!module.enabled) {
  //     this.clearPermissions(module);
  //     this.disableAllChildren(module);
  //   }
  // }
  // clearPermissions(module: any): void {
  //   const allPermissions = this.permissions.map(p => p.name);
  //   for (const perm of allPermissions) {
  //     module.permissions[perm] = false;
  //   }
  //   module.enabled = false;
  // }
  // propagateToParent(modules: any[], child: any): boolean {
  //   for (const mod of modules) {
  //     if (mod.children && mod.children.includes(child)) {
  //       this.syncParentPermissions(mod);
  //       return true;
  //     } else if (mod.children?.length) {
  //       if (this.propagateToParent(mod.children, child)) {
  //         this.syncParentPermissions(mod);
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // }

  // syncParentPermissions(parent: any): void {
  //   const allPermissions = this.permissions.map(p => p.name);
  //   for (const perm of allPermissions) {
  //     // If parent already has the permission, keep it
  //     // If any child has the permission, enable it
  //     parent.permissions[perm] = parent.permissions[perm] || parent.children.some(child => child.permissions?.[perm]);
  //   }

  //   // Update parent.enabled based on updated permissions
  //   parent.enabled = Object.values(parent.permissions).some(val => val === true);
  // }


  checkAndEnableParent(module: any): void {
    const hasActiveChild = module.children?.some(child =>
      child.enabled || Object.values(child.permissions).some(p => p)
    );
    module.enabled = hasActiveChild;
  }

  // onToggleChange(module: any): void {
  //   if (!module.enabled) {
  //     this.disableAllChildren(module);
  //     this.clearPermissions(module);
  //   }
  // }

  // disableAllChildren(module: any): void {
  //   if (!module.children) return;

  //   for (const child of module.children) {
  //     this.clearPermissions(child);
  //     this.disableAllChildren(child);
  //   }
  // }
  MenuId: any
  deleteMenu(menu: any) {
    this.showDeleteDialog = true;
    this.MenuId = menu.id
    // if (confirm(`Are you sure you want to delete "${menu.name}"?`)) {

    // }
  }
  confirmDelete() {
    const sub = this.apiService.deleteAPI(`/access/menus/${this.MenuId}/`).subscribe({
      next: () => {
        this.showDeleteDialog = false;
        this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Menu deleted successfully' });
        this.getUserMapping(); // or re-fetch your menu list
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not delete menu' });
        console.error('Delete error:', err);
      }
    });
    this.mySubscription.add(sub)
  }
  getParentMenu() {
    const sub = this.apiService.getAPI('/access/menus/').subscribe((res: any[]) => {
      if (res) {
        this.parentMenuOptions = res;
      }
    })
    this.mySubscription.add(sub)
  }


  toggleExpand(menuId: number) {
    if (this.expandedMenus.has(menuId)) {
      this.expandedMenus.delete(menuId); // collapse
    } else {
      this.expandedMenus.add(menuId); // expand
    }
  }
  onPermissionChange(module: any, permissionName: string): void {
  // Update the module's enabled status based on permissions
  module.enabled = Object.values(module.permissions).some(val => val === true);

  // Propagate changes downward to children
  if (module.children?.length) {
    this.propagateToChildren(module, permissionName);
  }

  // Propagate changes upward to parents
  this.propagateToParent(this.flatModules, module);
}

propagateToChildren(parent: any, permissionName: string): void {
  if (!parent.children || parent.children.length === 0) return;

  const newValue = parent.permissions[permissionName];
  
  parent.children.forEach(child => {
    // Only update if the value is different to prevent unnecessary changes
    if (child.permissions[permissionName] !== newValue) {
      child.permissions[permissionName] = newValue;
      child.enabled = Object.values(child.permissions).some(val => val === true);
      
      // Recursively propagate to grandchildren
      this.propagateToChildren(child, permissionName);
    }
  });
}

propagateToParent(modules: any[], changedModule: any): boolean {
  for (const module of modules) {
    // Check if this module is the direct parent
    if (module.children?.includes(changedModule)) {
      this.syncParentPermissions(module);
      return true;
    }
    
    // Otherwise search recursively in children
    if (module.children?.length) {
      const foundInChildren = this.propagateToParent(module.children, changedModule);
      if (foundInChildren) {
        this.syncParentPermissions(module);
        return true;
      }
    }
  }
  return false;
}

syncParentPermissions(parent: any): void {
  let anyPermissionChanged = false;
  
  this.permissions.forEach(perm => {
    const oldValue = parent.permissions[perm.name];
    const newValue = parent.children.some(child => child.permissions[perm.name]);
    
    if (oldValue !== newValue) {
      parent.permissions[perm.name] = newValue;
      anyPermissionChanged = true;
    }
  });

  // Only update enabled status if permissions actually changed
  if (anyPermissionChanged) {
    parent.enabled = Object.values(parent.permissions).some(val => val === true);
  }
}

onToggleChange(module: any): void {
  if (!module.enabled) {
    this.clearPermissions(module);
    if (module.children?.length) {
      this.disableAllChildren(module);
    }
  } else {
    // When enabling a module, ensure at least one permission is checked
    if (!Object.values(module.permissions).some(val => val === true)) {
      // Default to checking the first permission if none are selected
      const firstPermission = this.permissions[0]?.name;
      if (firstPermission) {
        module.permissions[firstPermission] = true;
        this.onPermissionChange(module, firstPermission);
      }
    }
  }
}

disableAllChildren(module: any): void {
  if (module.children?.length) {
    module.children.forEach(child => {
      this.clearPermissions(child);
      child.enabled = false;
      this.disableAllChildren(child);
    });
  }
}

clearPermissions(module: any): void {
  this.permissions.forEach(perm => {
    module.permissions[perm.name] = false;
  });
  module.enabled = false;
}
    get canEditSetup(): boolean {
  return this.permissionService.hasPrivilege('/setup', 'Add') ||
         this.permissionService.hasPrivilege('/setup', 'Edit') ||
         this.permissionService.hasPrivilege('/setup', 'Delete');
}
}
